import { useState } from 'react';
import { Container, Pagination, styled } from '@mui/material';
import { IApiCallStatus, IDeaRegistration, ValueLabel } from '../common';
import { render } from '.';

export function Registrations2d({
  properties,
  deaRegistrations,
  getRegistrationsCallStatus,
}: {
  properties: ValueLabel<keyof IDeaRegistration>[];
  deaRegistrations: IDeaRegistration[];
  getRegistrationsCallStatus: IApiCallStatus;
}) {
  const [page, setPage] = useState(1);
  const pageSize = 100;

  switch (getRegistrationsCallStatus) {
    case null:
      return <Container maxWidth="lg">Loading...</Container>;

    case false:
      return <Container maxWidth="lg">Error</Container>;

    case true:
      return (
        <>
          {deaRegistrations.length > pageSize && (
            <Paginatio
              count={Math.ceil(deaRegistrations.length / pageSize)}
              page={page}
              onChange={(z, page) => setPage(page)}
              shape="rounded"
            />
          )}

          {render(properties)(
            deaRegistrations.slice((page - 1) * pageSize, page * pageSize)
          )}

          {deaRegistrations.length > pageSize && (
            <Paginatio
              count={Math.ceil(deaRegistrations.length / pageSize)}
              page={page}
              onChange={(z, page) => setPage(page)}
              shape="rounded"
            />
          )}
        </>
      );

    case void 0:
      return null;
  }
}

const Paginatio = styled(Pagination)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
}));
